export const IS_PROD = (ENV_TAGS || []).indexOf("Prod") >= 0; //webpack.DefinePlugin

export default {
  authenticationVerificationInterval: IS_PROD ? 20000 : 45000,
  autoLogoutTimeout: -1,
  autoLoginPrompt: true,
};
